<template>
<!--顶部-->
<div>
  <div class='top_search_holder'>
      <div class='top_search_wrapper'>
        <div class='top_search_classify' @click="navShow">
          <p class='icon-classify'></p>
          <p class='top_search_classify_name'>{{catalog.substring(0,2)}}</p>
        </div>
        <div class='top_search'>
          <input type='search' class='top_search_input' :placeholder="goodPlaceholder" @keyup.enter="storeKeys" id="search_text" />
            <span class='icon-search icon_search'></span>
        </div>
        <router-link to="/userCenter/help" class='top_search_course'>
          <div class='top_search_play_icon_wrapper'>
            <span class='icon-play'></span>
          </div>
          <p class='top_search_play_name'>
            帮助
          </p>
        </router-link>
      </div>
  </div>
  <mt-popup v-model="navShowFlag"  position="top" modal="true" closeOnClickModal="true" class="pop_nav_all" >
      <div>
        <ul class="catalog_wrapper">
          <li v-for="(catalogList) in catalogList"  class="catalog_cell" :key="catalogList.catalogList" @click="classifyGoods(catalogList.goodsCat,catalogList.catalog)" >
{{catalogList.catalog}}
          </li>
        </ul>
      </div>

  </mt-popup>
</div>
</template>
<script type = "text/ecamscript-6">
import Vue from 'vue'
import { Popup } from 'mint-ui'
Vue.component(Popup.name, Popup);
import catalogList from "../../configFile/catalog/catalog.json"
export default {
    name:"topSearch",
    data(){
      return{
        localHistoryKeys:'',
        navShowFlag:false,
        catalogList:catalogList.catalogListArray,
        cat:"",
        catalog:"分类",
        goodPlaceholder:"粘贴商品标题试试"
      }
    },
    methods:{
      clipGoodsid: function(goodsID, cb) { //从喵口令的goodis  获取title
        let kUrl = "api/getTitleByGoodid.php?id=" + goodsID
        //console.log(this.url )
        this.$ajax.autoService
          .login(kUrl)
          .then((res) => {
            var title = res.data.results.n_tbk_item["0"].title
            typeof cb == "function" && cb(title) //如果从聚口令令中得到标题，就返回标题
          //  console.log(this.item)
          }, (res) => {
            //console.log("error")
          })
      },
      clipPasswordData: function(password, cb) {
        let url = ''
        let goodsID = ''
        let content = ''
        let tUrl = "api/getPasswordContent.php?password=" + password
        //console.log(this.url )
        this.$ajax.autoService
          .login(tUrl)
          .then((res) => {
            //console.log(res)
            url = res.data.url + '&'
            content = res.data.content

            if (url.match(/item[Ii][Dd]=.*?&/)) {
              goodsID = url.match(/item[Ii][Dd]=.*?&/)[0].replace(/item[Ii][Dd]=/, '').replace("&", '')
            } else if (url.match(/[&\?][Ii][Dd]=.*?&/)) {
              goodsID = url.match(/[&\?][Ii][Dd]=.*?&/)[0].replace(/[&\?][Ii][Dd]=/, '').replace("&", '')
            }
            //console.log('goodsid:' + goodsID)
            if (goodsID != '') {
              let t1Url = "api/getTitleByGoodid.php?id=" + goodsID
              this.$ajax.autoService
                .login(tUrl)
                .then((res) => {
                  console.log(res)
                  let title = res.data.content
                  typeof cb == "function" && cb(title) //如果从淘口令中得到标题，就返回标题
                })
            } else {
              content = content.replace(/\r|\n/g, '')
              content = content.replace(/\.\.\..*$/, '')
              content = content.replace(/【.*$/, '')
              typeof cb == "function" && cb(content) //如果从淘口令中得到标题，就返回标题
            }
          }, (res) => {
            console.log("error")
          })
      },
      storeKeys: function() {
        //console.log(document.querySelector('#search_text').value)
        this.searchValue = document.querySelector('#search_text').value;
        var that = this
        //正则匹配关键词
        if (this.searchValue.match(/喵口令/)) {
          var tmallTitle = this.searchValue.match(/【.*】/)[0].replace('【', '').replace('】', '')
          //console.log(tmallTitle)
          that.searchValue = tmallTitle
          that.routeJump()
        } else if (this.searchValue.match(/item_id=\d*&/)) { //如果是聚口令分享过来的，解析出GOODSID
          //console.log(this.searchValue.match(/item_id=\d*&/)[0])
          goodsid = this.searchValue.match(/item_id=\d*&/)[0].replace('item_id=', '').replace('&', '')
          this.clipGoodsid(goodsid, function(title) {
            that.searchValue = title
            that.routeJump()
            //that.searchDo(keyword, formId)
          })
        } else if (this.searchValue.match(/(\?|&)id=\d*&/)) {
          //console.log(this.searchValue.match(/(\?|&)id=\d*&/)[0])
          goodsid = this.searchValue.match(/(\?|&)id=\d*&/)[0].replace(/(\?|&)id=/, '').replace('&', '')
          //console.log(goodsid)
          this.clipGoodsid(goodsid, function(title) {
            that.searchValue = title
            that.routeJump()
          })
        } else if (this.searchValue.match(/￥.*?￥/)) { //对keyword进行处理，如果包含淘口令的，解析出标题
          var tempTKL = this.searchValue.match(/￥.*?￥/)[0]
          var tempKeyword
          this.clipPasswordData(tempTKL, function(title) {
            //console.log("最后搜索关键词:" + title)
            that.searchValue = title
            that.routeJump()
          })
        } else if (this.searchValue.match(/€.*?€/)) { //对keyword进行处理，如果包含淘口令的，解析出标题
          var tempTKL = this.searchValue.match(/€.*?€/)[0]
          var tempKeyword
          this.clipPasswordData(tempTKL, function(title) {

            that.searchValue = title
            //console.log("最后搜索关键词:" + that.searchValue)
            that.routeJump()
          })
        } else {
          this.routeJump()
        } //路由跳转以及历史搜索词

        // this.historyKeys.push(document.querySelector('#search_text').value)
        //  localStorage.setItem("nameSpace", "[1,2]");
        //console.log(JSON.parse(localStorage.nameSpace))
      },
      routeJump: function() {//路由跳转
        this.$router.push({
          name: 'searchResulte',
          query: {
            keyWord: this.searchValue,
            cat:this.cat

          }
        })
        //console.log(this.searchValue)
        this.$store.dispatch("changeLocalHistoryKeys",this.searchValue)//储存搜索关键词
      },
      navShow: function() {
        this.navShowFlag = !this.navShowFlag;
      },
      classifyGoods:function(cat,catalog){
        this.cat = cat;
        this.navShowFlag = !this.navShowFlag;
        this.catalog = catalog;
        this.goodPlaceholder = "已为您切换到"+catalog
      }
    }
  }
</script>
<style lang="stylus">
  .top_search_holder
    width:100%
    height:100px
    .top_search_wrapper
      padding: 20px 25px
      /* background: rgba(255,255,255,0.95); */
      background: rgb(255, 255, 255)
      border-top: 1px solid #ddd
      width: 100%
      display: flex
      justify-content: space-between
      box-sizing: border-box
      position: fixed
      top: 0px
      left: 0px
      z-index: 30
      border-bottom: 1px solid #ddd
      .top_search_classify
        width:60px
        text-align:center
        padding-top:10px
        .top_search_classify_name
          font-size:24px
          color:#666
      .top_search
        width: 515px
        height: 60px
        border-radius: 30px
        background: #eee
        position: relative
        line-height:60px
        .top_search_input
          width: 515px
          padding-left:40px
          height: 60px
          box-sizing:border-box
        .icon_search
          position:absolute
          top:18px
          left:10px
      .top_search_course
        width:60px
        padding-top:10px
        .top_search_play_icon_wrapper
          width:30px
          height:25px
          border:1px solid #f74b53
          line-height:25px
          text-align:center
          margin:0 auto
        .top_search_play_name
          font-size:24px
          color:#666
  .pop_nav_all
    width:100%
    top:0px
    .catalog_wrapper
      background:#fff
      padding:30px
      .catalog_cell
        background:#f2f2f2
        display:inline-block
        padding:20px 30px
        border-radius:10px
        font-size:28px
        margin:10px

</style>



// WEBPACK FOOTER //
// src/components/common/topSearch.vue